<script lang="ts">
  import { Button, Image } from "sveltestrap";
  import { href } from "../../../../utils/Constant/Constant";
  import Link from "svelte-link";
  export let wishlistItem
  let imgPath:string = "/assets/images/ecommerce"
</script>
<div class="media">
    <Link href={href}>
        <Image fluid class="align-self-center" src="{imgPath}/{wishlistItem.img}" alt="#" />
    </Link>
    <div class="media-body">
        <div class="product-name">
            <Link href={href}>
                <h6>{wishlistItem.name}</h6>
            </Link>
        </div>
        <ul class="rating">
            <li><i class="fa fa-star"></i></li>
            <li><i class="fa fa-star"></i></li>
            <li><i class="fa fa-star"></i></li>
            <li><i class="fa fa-star"></i></li>
            <li><i class="fa fa-star"></i></li>
        </ul>
        <div class="price">
            {wishlistItem.title}<span>: {wishlistItem.amount}</span>
        </div>
        <div class="avaiabilty">
            <div class="text-success">{wishlistItem.stock}</div>
        </div>
        <Button color="primary" class="btn-xs" href={href}>{wishlistItem.btn}</Button>
    </div>
</div>